import { ChangeEvent, FormEvent, useState } from "react";
import { DotLoader } from "../../components/dotLoader";
import {
  RadioOption,
  TableTitle,
} from "../../components/mobileSize/TableTitle";
import { CustomListType, DetectDetail } from "../../types/types";
import styled from "@emotion/styled";
import { /*DetectData, */FetchParams } from "./detectList";
import Calendars from "../../components/calendars";
import { Box, SelectChangeEvent } from "@mui/material";
import SelectBox from "../../components/selectBox";
import { getEventOptions, getMobileOptions } from "../../utils/constants";
import { SearchForm } from "../../components/common/SearchForm";
import { FileDownloadIcon, GrayClassAndBoardIcon } from "../../assets/icons/icons";
//import { useNavigate } from "react-router-dom";
import theme from "../../theme";
import Spinner from "../../components/spinner";
import { MobileTable } from "../../components/mobileSize/MobileTable";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import { formatDate } from "../../utils/util";
import userStorage from "../../utils/userStorage";
import { SelectBoxGroupId } from "../../components/SelectBoxGroupId";
import { useI18n } from "../../locales";
//import EventDetailModal from "./eventDetailModal";

const SORT_LIST: RadioOption[] = [
  { label: `기본 순`, value: `` },
  { label: `감지번호 순`, value: `header_seq` },
  { label: `기기종류 순`, value: `mobility_type` },
  { label: `기기명 순`, value: `mobility_name` },
  { label: `소유자 순`, value: `owner` },
  { label: `감지내역 순`, value: `code_name` },
  { label: `감지일시 순`, value: `registered_at` },
  { label: `해제일시 순`, value: `reason_dt` },
  { label: `해제사유 순`, value: `reason` },
  { label: `조치자 순`, value: `checker_name` },
];

const DOWNLOADABLE_GOV_IDS = [""];

type Prop = {
  data?: CustomListType<DetectDetail[]>;
  isLoading?: boolean;
  sort?: string;
  setSort?: React.Dispatch<React.SetStateAction<string | undefined>>;
  setNoData: React.Dispatch<React.SetStateAction<boolean>>;
  onClickBtn: ({
    startDate,
    endDate,
    searchKey,
    detFilter,
    mobFilter,
  }: FetchParams) => void;
  onClickDown?: () => void;
  downIsPending?: boolean;
  onClickDetailIcon: (seq: number) => void;
};

export const MobileDetecList = ({
  data,
  isLoading,
  sort,
  setSort,
  //setNoData,
  onClickBtn,
  onClickDown,
  downIsPending,
  onClickDetailIcon,
}: Prop) => {
  const { t } = useI18n();
  //const navigate = useNavigate();
  const user = userStorage.get();
  const [openFilter, setOpenFilter] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [mobFilterOpen, setMobFilterOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [input, setInput] = useState("");
  const [mobFilter, setMobFilter] = useState(-1); // 가짜
  const [detFilter, setDetFilter] = useState(0); // 진짜
  const isDownloadableUser = DOWNLOADABLE_GOV_IDS.some((el) =>
    user?.gov_id.includes(el)
  ); // 엑셀파일 다운로드 기능 사용 가능한지 여부
  const [groupSub, setGroupSub] = useState("all"); // 하위그룹코드(화면용)

  const handleChange = (event: SelectChangeEvent) => {
    setDetFilter(Number(event.target.value));
  };

  const handleClose = () => {
    setFilterOpen(false);
  };

  const handleOpen = () => {
    setFilterOpen(true);
  };

  const mobHandleChange = (event: SelectChangeEvent) => {
    setMobFilter(Number(event.target.value));
  };

  const mobHandleClose = () => {
    setMobFilterOpen(false);
  };

  const mobHandleOpen = () => {
    setMobFilterOpen(true);
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInput(event.currentTarget.value);
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onClickBtn({
      startDate,
      endDate,
      mobFilter,
      detFilter,
      searchKey: input,
      groupId: groupSub,
    });
  };

  // 지도에서 보기
  // const onClickMapIcon = (el: DetectData) => {
  //   // 좌표값 없는 경우 리턴
  //   if (!el.latitude || !el.longitude) {
  //     setNoData(true);

  //     setTimeout(() => {
  //       setNoData(false);
  //     }, 1000);
  //     return;
  //   }
  //   navigate(`/control/past`, {
  //     state: {
  //       from: "detectList",
  //       data: el,
  //       start: startDate,
  //       end: endDate,
  //       mobility_code: mobFilter,
  //       event_code: detFilter,
  //       input,
  //     },
  //   });
  // };

  return (
    <>
      {/* 필터 섹션 */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: openFilter ? "auto" : "0px",
          maxHeight: openFilter ? "100vh" : "0px",
          overflow: openFilter ? "visible" : "hidden",
          gap: "6px",
          paddingBottom: openFilter ? "16px" : "0px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: `8px`,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SelectBox
            open={mobFilterOpen}
            filter={mobFilter}
            handleChange={mobHandleChange}
            handleClose={mobHandleClose}
            handleOpen={mobHandleOpen}
            title="기기 종류 선택"
            menuItems={getMobileOptions(t)}
            width={140}
            mr="0px"
            srLabel="기기 종류 선택"
          />
          <SelectBox
            open={filterOpen}
            handleChange={handleChange}
            handleOpen={handleOpen}
            handleClose={handleClose}
            filter={detFilter}
            menuItems={getEventOptions(t)}
            title="감지 종류 선택"
            width={140}
            mr="0px"
            srLabel="감지 종류 선택"
          />
        </Box>

        <Calendars
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          isSeparate={false}
          width={140}
          justifyContent="center"
          gap="8px"
        ></Calendars>

        <Box
          sx={{
            display: "flex",
            gap: `8px`,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* 하위 그룹 조회 */}
          <SelectBoxGroupId
            groupSub={groupSub}
            setGroupSub={setGroupSub}
            width={140}
          />

          <Box
            sx={{
              width: "140px",
            }}
          ></Box>
        </Box>
        <SearchForm
          onSubmit={onSubmit}
          placeholder="기기 명, 소유자 명을 검색"
          onChange={onChange}
          inputValue={input}
          setInputValue={setInput}
          width="100%"
          direction="column"
          gap="6px"
          bottom="0"
          marginR="0"
        />
      </Box>

      {/* 테이블 타이틀 섹션 */}
      <TableTitle
        title={
          isLoading ? (
            <div style={{ height: "15px" }}>
              <DotLoader height="6px" />
            </div>
          ) : (
            `조회된 감지이력 - ${data?.total_items ?? 0} 건`
          )
        }
        sort={sort}
        setSort={setSort}
        setOpenFilter={setOpenFilter}
        sortList={SORT_LIST}
        icon={
          isDownloadableUser && (
            <CustomTooltip title="감지내역 다운" active>
              <FileDownloadButton
                onClick={onClickDown}
                disabled={downIsPending}
              >
                <FileDownloadIcon
                  width="24px"
                  height="24px"
                  color={theme.color.green_500}
                />
              </FileDownloadButton>
            </CustomTooltip>
          )
        }
      />

      {/* 테이블 섹션 */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          flexGrow: 1,
        }}
      >
        {isLoading && <Spinner />}
        {data &&
          data.list.length > 0 &&
          data.list.map((el) => (
            <MobileTable
              key={el.header_seq}
              defaultInfo={
                <>
                  <TextWrapper>
                    {/* 감지일시 */}
                    <Text
                      style={{
                        alignSelf: "end",
                      }}
                    >
                      {formatDate(el?.registered_at, "yyyy-MM-dd HH:mm")}
                    </Text>
                    {/* 감지 내역 */}

                    <WarningText isDanger={el.code_name === "차량전복"}>
                      {el.code_name}
                    </WarningText>
                  </TextWrapper>
                  <TextWrapper>
                    {/* 감지 번호 */}
                    <Text>{el.header_seq}</Text>
                    {/* 기기명 */}
                    <CustomTooltip title={el?.mobility_name} active>
                      <Text
                        $fontSize={theme.fontSize.FONT_1}
                        style={{ textAlign: "right" }}
                      >
                        {el.mobility_name}
                      </Text>
                    </CustomTooltip>
                  </TextWrapper>
                  <TextWrapper>
                    {/* 기기종류 */}
                    <CustomTooltip title={el?.mobility_type} active>
                      <Text $fontSize={theme.fontSize.FONT_1}>
                        {el.mobility_type}
                      </Text>
                    </CustomTooltip>
                    {/* 소유자 */}
                    <CustomTooltip title={el?.owner} active>
                      <Text
                        $fontSize={theme.fontSize.FONT_1}
                        style={{ textAlign: "right" }}
                      >
                        {el.owner}
                      </Text>
                    </CustomTooltip>
                  </TextWrapper>
                </>
              }
              icons={
                // 감지내역 상세보기 아이콘
                <CustomTooltip title={"감지내역 상세보기"} active>
                  <IconWrapper onClick={() => onClickDetailIcon(el.header_seq)}>
                    <GrayClassAndBoardIcon />
                  </IconWrapper>
                </CustomTooltip>
              }
              // icons={
              //   // 지도에서 보기 아이콘
              //   <CustomTooltip title={"지도에서 보기"} active>
              //     <IconWrapper onClick={() => onClickMapIcon(el)}>
              //       <GrayMapIcon />
              //     </IconWrapper>
              //   </CustomTooltip>
              // }
              detailInfo={
                <Table>
                  <tbody>
                    {/* 해제일시 */}
                    <DetailWrapper>
                      <DetailTitle
                        $fontWeight={theme.fontWeight.SEMI_BOLD}
                      >{`해제일시`}</DetailTitle>
                      <DetailText $fontWeight={theme.fontWeight.SEMI_BOLD}>
                        {el.reason_dt
                          ? formatDate(el?.reason_dt, "yyyy-MM-dd HH:mm")
                          : ""}
                      </DetailText>
                    </DetailWrapper>
                    {/* 해제사유 */}
                    <DetailWrapper>
                      <DetailTitle>{`해제사유`}</DetailTitle>
                      <DetailText $fontWeight={theme.fontWeight.SEMI_BOLD}>
                        {el.reason}
                      </DetailText>
                    </DetailWrapper>
                    {/* 조치자 */}
                    <DetailWrapper>
                      <DetailTitle>{`조치자`}</DetailTitle>
                      <DetailText $fontWeight={theme.fontWeight.SEMI_BOLD}>
                        {el.checker_name}
                      </DetailText>
                    </DetailWrapper>
                  </tbody>
                </Table>
              }
            />
          ))}
        {!isLoading && data && data.list.length === 0 && (
          <NoDataMassage>조회된 데이터가 없습니다.</NoDataMassage>
        )}
      </Box>
    </>
  );
};

const IconWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${theme.color.neutral_200};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 18px;
    height: 18px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(
    100vw - 32px - 32px - 38px - 16px
  ); /* 외부패딩 - 내부패딩 - 아이콘너비 - 갭 */
  height: 20px;
`;

const Text = styled.div<{ $fontSize?: string; $width?: string }>`
  font-size: ${({ $fontSize }) =>
    $fontSize ? $fontSize : theme.fontSize.FONT_2};
  line-height: 20px;
  flex: ${({ $width }) => ($width ? `0 1 ${$width}` : "1")};
  width: ${({ $width }) => ($width ? $width : "45%")};
  max-width: ${({ $width }) => ($width ? $width : "45%")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const WarningText = styled.p<{ isDanger: boolean }>`
  background: ${({ isDanger }) =>
    isDanger ? `${theme.color.red_500}` : `${theme.color.red_100}`};
  color: ${({ isDanger }) =>
    isDanger ? `${theme.color.orange_100}` : `${theme.color.orange_500}`};
  border-radius: 3px;
  border: ${({ isDanger }) =>
    !isDanger && `0.5px solid ${theme.color.orange_500}`};
  padding: 2px 4px;
  height: 20px;
  line-height: 20px;
  display: flex;
  font-size: ${theme.fontSize.FONT_2};
  align-items: center;
  justify-content: center;
`;

const NoDataMassage = styled.div`
  text-align: center;
  color: ${theme.color.neutral_500};
  padding-top: 200px;
`;

const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;

  td {
    border: 0.5px solid ${theme.color.neutral_100};
  }
`;

const DetailWrapper = styled.tr`
  display: flex;
  height: 24px;
  border-collapse: collapse;
`;
const DetailTitle = styled.td<{ $fontWeight?: string }>`
  width: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.fontSize.FONT_2};
  font-weight: ${({ $fontWeight }) =>
    $fontWeight ? $fontWeight : theme.fontWeight.NORMAL};
  padding: 4px 8px;
  background-color: ${theme.color.neutral_50};
`;
const DetailText = styled.td<{ $fontWeight: string }>`
  flex-grow: 1;
  display: flex;
  align-items: center;
  font-size: ${theme.fontSize.FONT_2};
  font-weight: ${({ $fontWeight }) =>
    $fontWeight ? $fontWeight : theme.fontWeight.NORMAL};
  padding: 4px 8px;
`;

const FileDownloadButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  z-index: 2;
  padding: 0;
  height: 24px;

  &:disabled {
    svg {
      fill: ${theme.statusColor.DISABLED};
      cursor: default;
    }
  }
`;
